/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl-next';

import { cssMap, cx, jsx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';

import { i18n } from './messages';

const styles = cssMap({
	text: {
		textDecoration: 'none',
	},
});

export const AIAwareness = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={cx(styles.text)}>
			<Inline alignBlock="center" space="space.050">
				<RovoIcon size="xxsmall" appearance="brand" shouldUseNewLogoDesign />
				<Text color="color.text.subtlest">{formatMessage(i18n.rovoAwarenessMessage)}</Text>
			</Inline>
		</Box>
	);
};
